module.exports = __webpack_public_path__ + "img/office5.9ce914b2.jpg";